import { useGet } from "./api";

export default function () {
  const currentItemQuery = useGet(`tax-weeks/date`);
  return currentItemQuery?.data?.value?.weekNumber;
}
